import { useMediaQuery, useTheme } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import { isMobile } from 'react-device-detect';

export const useResponsiveSize = (screenSize: Breakpoint, deviceSensitive?: boolean): boolean => {
    const theme = useTheme();
    const isMediumScreenSize = useMediaQuery(theme.breakpoints.down(screenSize));

    return isMediumScreenSize || (isMobile && !!deviceSensitive);
};
